import { ChevronRight } from 'lucide-react';
import { useLocation, useParams, matchPath, Link } from 'react-router-dom';

const AdminBreadcrumbs = () => {
  const location = useLocation();
  const params = useParams();
  
  const getBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter(x => x);
    const breadcrumbs = [];
    
    // Admin root
    breadcrumbs.push({ name: 'Admin', path: '/admin' });
    
    let accumulatedPath = '/admin';
    pathnames.forEach((name, index) => {
      if (index === 0) return; // Skip 'admin' since it already exists
      
      accumulatedPath += `/${name}`;
      
      let displayName = name;
      
      // Check if this segment is an ID
      if (!isNaN(name)) {
        // Use the previous segment as context
        const resource = pathnames[index - 1];
        displayName = `${resource.slice(0, -1)} #${name}`; // Convert "jobs" to "job #90"
      } else {
        displayName = name.replace(/-/g, ' ');
      }
      
      breadcrumbs.push({
        name: displayName,
        path: index === pathnames.length - 1 ? null : accumulatedPath // No link for current page
      });
    });
    
    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <div className="flex items-center space-x-2 text-sm text-secondary-500">
      {breadcrumbs.map((breadcrumb, index) => (
        <span key={breadcrumb.path || breadcrumb.name} className="flex items-center">
          {breadcrumb.path ? (
            <Link to={breadcrumb.path} className="hover:text-secondary-700 capitalize">
              {breadcrumb.name}
            </Link>
          ) : (
            <span className="text-secondary-700 font-medium capitalize">
              {breadcrumb.name}
            </span>
          )}
          {index < breadcrumbs.length - 1 && <ChevronRight size={14} className="mx-2" />}
        </span>
      ))}
    </div>
  );
};


export default AdminBreadcrumbs;